var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "fieldset",
      [
        _c("h3", { staticClass: "modal-title" }, [
          _vm._v("ADD GROUP APPLICATION")
        ]),
        _vm._v(" "),
        _c(
          "b-form-group",
          { class: { "error-input": _vm.$v.group.groupName.$error } },
          [
            _c("label", { attrs: { for: "groupName" } }, [
              _vm._v(" Group Name* ")
            ]),
            _vm._v(" "),
            _c("j-input", {
              attrs: { id: "groupName", placeholder: "Enter group name here" },
              model: {
                value: _vm.$v.group.groupName.$model,
                callback: function($$v) {
                  _vm.$set(_vm.$v.group.groupName, "$model", $$v)
                },
                expression: "$v.group.groupName.$model"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-form-group",
          { class: { "error-input": _vm.$v.group.descName.$error } },
          [
            _c("label", { attrs: { for: "descName" } }, [
              _vm._v(" Description* ")
            ]),
            _vm._v(" "),
            _c("j-textarea", {
              attrs: {
                id: "descName",
                disabled: false,
                placeholder: "Enter group description here"
              },
              model: {
                value: _vm.$v.group.descName.$model,
                callback: function($$v) {
                  _vm.$set(_vm.$v.group.descName, "$model", $$v)
                },
                expression: "$v.group.descName.$model"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pull-right" },
          [
            _c(
              "b-button",
              { staticClass: "btn", on: { click: _vm.closeCreateGroupModal } },
              [_vm._v("\n        Close\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "btn",
                attrs: { variant: "primary" },
                on: { click: _vm.createGroup }
              },
              [_vm._v("\n        Add\n      ")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac7e5952", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac7e5952","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/jModalCreateGroup.vue
// module id = null
// module chunks = 